import { planetWatchBullets } from "./TTHTPlanetWatchSection.consts";
import { TTHTBullet } from "../../../../components/TTHTBullet";
import React from "react";
import {
  TTHTPlanetWatchImageContainer,
  TTHTPlanetWatchContentWrapper,
  TTHTPlanetWatchTextContainer,
} from "./TTHTPlanetWatchSection.styled";
import {
  TTHTSectionContent,
  TTHTSectionTitle,
  TTHTSectionText,
  TTHTSection,
  TTHTSectionWrapper,
} from "../../../TeachersToolkitHowTo.styled";

export const TTHTPlanetWatchSection = () => (
  <TTHTSection bgcolor="#FFFFFF">
    <TTHTSectionWrapper>
      <TTHTSectionContent>
        <TTHTPlanetWatchContentWrapper>
          <TTHTPlanetWatchTextContainer>
            <TTHTSectionTitle size="sm">Planet Watch App</TTHTSectionTitle>
            <TTHTSectionText>
              Through the Planet Watch app, you can have quick access to your
              school's data at the click of a button.
            </TTHTSectionText>
            <br />
            {planetWatchBullets.map((bullet, index) => (
              <TTHTBullet
                key={index}
                number={index + 1}
                title={bullet.name}
                text={bullet.description}
              />
            ))}
          </TTHTPlanetWatchTextContainer>
          <TTHTPlanetWatchImageContainer>
            <img className="img-fluid " src="/img/ttht/planet-watch.jpg" />
          </TTHTPlanetWatchImageContainer>
        </TTHTPlanetWatchContentWrapper>
      </TTHTSectionContent>
    </TTHTSectionWrapper>
  </TTHTSection>
);



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitHowTo/components/Sections/PlanetWatch/TTHTPlanetWatchSection.js